import {getStartJob} from "../../api/startJob";

const state = () => ({

    startJob:{},
})


const getters = {
    get_startJob(state) {
        return state.startJob;
    },
}

const mutations = {
    SET_STARTJOB(state,data){
        state.startJob = data;}
}

const actions = {
    async fetchStartJob({ commit }) {
        const response = await getStartJob();
            commit('SET_STARTJOB', response.data);

    },

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
